import * as React from 'react';
import { WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import PageTemplate from '../../components/template/PageTemplate';
import HomeTabListWrap from '../../views/home/HomeTabListWrap';

const HomeTabList = (): JSX.Element => {
  return (
    <PageTemplate pageName={WIDGET_PAGE_NAME.MAIN_TAB_MANAGEMENT}>
      <HomeTabListWrap />
    </PageTemplate>
  );
};

export default HomeTabList;
